import { BaseInterior } from './BaseInterior';
import { socketManager } from '../socket/SocketManager';

export class StashInterior extends BaseInterior {
  render(): void {
    this.drawRoom(0x3a3a2a, 0x5b5b4b);
    this.addExitButton();
    this.addTitle(this.building.name + ' - Planque');

    const si = this.stateData?.stashInfo;
    const { width, height } = this.scene.scale;

    if (!si) {
      this.addLabel(80, height / 2, 'Planque pas encore configuree.', '#ff9800', '14px');
      return;
    }

    let y = 100;
    const leftCol = 80;

    // Capacity bar
    this.addLabel(leftCol, y, `Capacite: ${si.usedCapacity}/${si.capacity} unites`, '#ffffff', '14px');
    y += 20;
    this.drawProgressBar(leftCol, y, 250, 16,
      si.capacity > 0 ? si.usedCapacity / si.capacity : 0, 0x333333, 0x4caf50);
    y += 35;

    // Stocks
    this.addLabel(leftCol, y, '--- STOCKS ---', '#ff6b35', '14px');
    y += 25;

    if (si.stocks.length === 0) {
      this.addLabel(leftCol, y, 'Planque vide', '#666666', '12px');
      y += 25;
    } else {
      for (const stock of si.stocks) {
        this.addLabel(leftCol, y, `${stock.drugType}: ${stock.quantity} unites`, '#ffffff', '13px');
        y += 20;
        this.drawProgressBar(leftCol + 20, y, 150, 10,
          si.capacity > 0 ? stock.quantity / si.capacity : 0, 0x333333, 0xffb347);
        y += 25;
      }
    }

    y += 10;
    this.addLabel(leftCol, y, '--- TRANSFERER ---', '#ff6b35', '14px');
    y += 25;

    // Transfer buttons for each stock to deal point
    for (const stock of si.stocks) {
      if (stock.quantity > 0) {
        const qty = Math.min(10, stock.quantity);
        this.addButton(leftCol + 120, y, `[ ${stock.drugType} x${qty} -> Deal Point ]`, '#3a6bc4', () => {
          // For now, transfer to first deal point - TODO: deal point selector
          socketManager.sendAction('MOVE_STOCK', {
            fromBuildingId: this.building.id,
            toBuildingId: 0, // Client should show a selector; placeholder
            drugType: stock.drugType,
            quantity: qty,
          });
          this.refreshAfterAction();
        });
        y += 35;
      }
    }

    // Crates decoration
    for (let row = 0; row < 3; row++) {
      for (let col = 0; col < 4; col++) {
        const cx = width - 220 + col * 45;
        const cy = 120 + row * 50;
        this.graphics.fillStyle(0x5d4037, 1);
        this.graphics.fillRect(cx, cy, 35, 25);
        this.graphics.lineStyle(1, 0x333333, 0.5);
        this.graphics.strokeRect(cx, cy, 35, 25);
      }
    }
  }

  private refreshAfterAction(): void {
    socketManager.onceActionResult(() => {
      socketManager.sendAction('ENTER_BUILDING', { buildingId: this.building.id });
    });
  }

  bindEvents(): void {}
}
